import {calculateErrorMessage} from 'common/helpers'

import type {WalkthroughSessionMeta} from '../core/DynamicWalkthroughContext'

const PENDING_WALKTHROUGH_KEY = 'pending-walkthrough'
const PENDING_WALKTHROUGH_MAX_AGE = 5 * 60 * 1000

export interface PendingWalkthrough {
  apiResponse: any
  timestamp: number
  currentStepIndex?: number
  sessionMeta?: WalkthroughSessionMeta
}

export function savePendingWalkthrough(
  apiResponse: any,
  currentStepIndex: number = 0,
  sessionMeta?: WalkthroughSessionMeta
) {
  try {
    const pending: PendingWalkthrough = {
      apiResponse,
      timestamp: Date.now(),
      currentStepIndex,
      sessionMeta,
    }
    sessionStorage.setItem(PENDING_WALKTHROUGH_KEY, JSON.stringify(pending))
  } catch (e) {
    calculateErrorMessage(e)
  }
}

export function updatePendingWalkthroughProgress(
  currentStepIndex: number,
  sessionMeta?: WalkthroughSessionMeta
) {
  try {
    const raw = sessionStorage.getItem(PENDING_WALKTHROUGH_KEY)
    if (!raw) return
    const parsed = JSON.parse(raw) as PendingWalkthrough
    if (!parsed || !parsed.apiResponse) return
    const updated: PendingWalkthrough = {
      ...parsed,
      currentStepIndex,
      timestamp: Date.now(),
      sessionMeta: sessionMeta ?? parsed.sessionMeta,
    }
    sessionStorage.setItem(PENDING_WALKTHROUGH_KEY, JSON.stringify(updated))
  } catch (e) {
    calculateErrorMessage(e)
  }
}

export function checkPendingWalkthrough(): PendingWalkthrough | null {
  try {
    const raw = sessionStorage.getItem(PENDING_WALKTHROUGH_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as PendingWalkthrough
    if (!parsed || !parsed.apiResponse) {
      sessionStorage.removeItem(PENDING_WALKTHROUGH_KEY)
      return null
    }
    if (Date.now() - parsed.timestamp > PENDING_WALKTHROUGH_MAX_AGE) {
      sessionStorage.removeItem(PENDING_WALKTHROUGH_KEY)
      return null
    }
    return parsed
  } catch (e) {
    calculateErrorMessage(e)
    return null
  }
}

export function clearPendingWalkthrough() {
  try {
    sessionStorage.removeItem(PENDING_WALKTHROUGH_KEY)
  } catch (e) {
    calculateErrorMessage(e)
  }
}

export default {
  savePendingWalkthrough,
  checkPendingWalkthrough,
  updatePendingWalkthroughProgress,
  clearPendingWalkthrough,
}
